import { createRouter, createWebHistory } from 'vue-router'
import util from '@/helper/util'
import App from '@/layouts/App.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: App
  },
  {
    path: '/:page(.*)*',
    name: 'page',
    component: App
  }
]

const router = createRouter({
  history: createWebHistory('/'),
  routes
})
router.beforeEach((to, from, next) => {
  util.axios.destroyRequests()
  next()
})

export default router
